var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "body",
      {
        staticClass:
          "home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container",
        staticStyle: { "overflow-y": "unset" },
        attrs: { "data-anchor": "pagetop" }
      },
      [
        _c("navbar", {
          attrs: {
            follow: "st-Header",
            imgSrc: "../../../../static/img/logo/logo-black.png"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "st-FixedPoint" }),
        _vm._v(" "),
        _c("div", { staticClass: "st-MainContainer" }, [
          _c(
            "main",
            {
              staticClass: "st-MainContents",
              staticStyle: { "padding-top": "120px" }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("section", { staticClass: "company-Profile" }, [
                _c("div", { staticClass: "company-Profile_Inner" }, [
                  _c(
                    "div",
                    {
                      staticClass: "st-Grid_Inner p-0 recruit-index-appear-1",
                      attrs: { "data-appear": "true" }
                    },
                    [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "common-text-appear text-center recruit-index-appear-2",
                          attrs: { "data-appear": "true" }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "sw-Section_Header-en pb-3" },
                            [
                              _c(
                                "b",
                                [
                                  _c(
                                    "font",
                                    [_c("font", [_vm._v("募集要項")])],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(1)
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "st-Breadcrumbs" }, [
            _c(
              "ul",
              {
                staticClass: "st-BreadcrumbsList",
                attrs: { itemscope: "itemscope", itemtype: "" }
              },
              [
                _c(
                  "li",
                  {
                    staticClass: "st-BreadcrumbsList_Item",
                    attrs: {
                      itemprop: "itemListElement",
                      itemscope: "itemscope",
                      itemtype: ""
                    }
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "st-BreadcrumbsList_Item-link",
                        attrs: { to: "/", itemprop: "item" }
                      },
                      [_vm._v("ホーム")]
                    ),
                    _vm._v(" "),
                    _c("meta", {
                      attrs: { itemprop: "position", content: "1" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._m(2)
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("copyright")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "series-PageTitle" }, [
      _c(
        "div",
        { staticClass: "series-PageTitle_Inner", attrs: { "data-appear": "" } },
        [
          _c("h1", [
            _c("span", { staticClass: "series-PageTitle_Logo" }, [
              _vm._v("RECRUIT")
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "series-PageTitle_Title",
                staticStyle: { color: "#FFF" }
              },
              [_vm._v("採用情報")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sw-parallax" }, [
            _c("div", { staticClass: "sw-parallax_outer js-parallax_outer" }, [
              _c("div", { staticClass: "sw-parallax_inner" }, [
                _c(
                  "div",
                  { staticClass: "sw-parallax_block js-parallax_block" },
                  [
                    _c("div", {
                      staticClass:
                        "sw-parallax_target promotion-PageTitle-visual",
                      staticStyle: {
                        background:
                          "url(../../../../static/img/recruit/RECRUIT.jpg) 50%/cover no-repeat",
                        top: "70px",
                        height: "480px"
                      }
                    })
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "company-Profile_List recruit-index-appear-3 mt-8 pt-6",
        attrs: { "data-appear": "true" }
      },
      [
        _c("dl", [
          _c("dt", [_vm._v("募集職種")]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "company-Profile_List-block" }, [
              _c("p", { staticClass: "company-Profile_List-text" }, [
                _vm._v(
                  "プロジェクトマネージャー(PM)／プロジェクトリーダー(PL)"
                ),
                _c("br"),
                _vm._v(
                  "\n                      システムエンジニア(SE)／プログラマー(PG)"
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("勤務地")]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "company-Profile_List-block" }, [
              _c("p", { staticClass: "company-Profile_List-text" }, [
                _vm._v("東京都内及びその周辺地域")
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("雇用形態")]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "company-Profile_List-block" }, [
              _c("p", { staticClass: "company-Profile_List-text" }, [
                _vm._v("正社員、契約社員")
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("給与")]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "company-Profile_List-block" }, [
              _c("p", { staticClass: "company-Profile_List-text" }, [
                _vm._v("200,000～600,000円"),
                _c("br"),
                _vm._v(
                  "\n                      ※給与は経験・能力等を考慮し決定致します。"
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("勤務時間")]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "company-Profile_List-block" }, [
              _c("p", { staticClass: "company-Profile_List-text" }, [
                _vm._v(
                  "\n                      ・週休2日制、有給休暇／夏季休暇／産前産後休暇／特別休暇／慶弔休暇／育児休暇／介護休暇\n                      "
                ),
                _c("br"),
                _vm._v(
                  "・健康保険、厚生年金保険、雇用保険、労災保険完備\n                    "
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("選考方法")]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "company-Profile_List-block" }, [
              _c("p", { staticClass: "company-Profile_List-text" }, [
                _vm._v("履歴書、職務経歴書による審査及び面接")
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", [_vm._v("応募方法")]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "company-Profile_List-block" }, [
              _c("p", { staticClass: "company-Profile_List-text" }, [
                _vm._v(
                  "\n                      履歴書(フリーフォーマット)および職務経歴書に日本語で記入した上、弊社の 採用応募における個人情報の取扱い をご同意いただけた場合のみ、下記の送信先に送信してください。\n                      "
                ),
                _c("br"),
                _vm._v(
                  "送信先: recruit@roboticsolutions.co.jp\n                      "
                ),
                _c("br"),
                _vm._v(
                  "選考通過者には、メールまたは電話にて面接日の調整をさせていただきます。\n                      "
                ),
                _c("br"),
                _vm._v(
                  "合否に関わらず一週間以内に選考の結果をご連絡いたします。\n                    "
                )
              ])
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "li",
      {
        staticClass: "st-BreadcrumbsList_Item",
        attrs: {
          itemprop: "itemListElement",
          itemscope: "itemscope",
          itemtype: ""
        }
      },
      [
        _c(
          "p",
          {
            staticStyle: { "margin-bottom": "0rem" },
            attrs: { itemprop: "item", "aria-current": "page" }
          },
          [_c("span", { attrs: { itemprop: "name" } }, [_vm._v("採用情報")])]
        ),
        _vm._v(" "),
        _c("meta", { attrs: { itemprop: "position", content: "3" } })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-236a9270", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-236a9270","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/recruit/recruit.vue
// module id = null
// module chunks = 